<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <app-arbitrary-search [arbitraryMode]="arbitraryMode" [(params)]="srmHospitalArbitraryResource.params"
                          (output)="search()"></app-arbitrary-search>
  </div>
</div>

<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-3">
      <div class="text-start col-4">
        <label class="col-form-label col-auto">
          <i class="bi bi-database me-2"></i>ผลการค้นหา
        </label>
      </div>
      <div class="text-end col-8">
        <button type="button"
                (click)="staticResource.downloadTemplateAndRename('hospital_arbitrary_condition.docx', 'วิธีการออกรายงาน.docx')"
                class="btn btn-primary me-2">
          <i class="bi bi-file-text"></i> วิธีการออกรายงาน
        </button>
        <button type="button"
                (click)="staticResource.downloadTemplateAndRename('hospital_arbitrary_condition.xlsx', 'เงื่อนไขออกรายงาน.xlsx')"
                class="btn btn-warning me-2">
          <i class="bi bi-file-excel"></i> เงื่อนไขออกรายงาน
        </button>
        <button type="button" class="btn btn-success me-2" [disabled]="!pageData?.content?.length"
                (click)="exportExcel()">
          <i class="bi bi-file-excel"></i> ส่งออกรายงาน
        </button>
      </div>
    </div>
    <hr>
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>
          แสดง {{ (pageData?.content?.length ? (pageData?.number * pageData?.size) + 1 : 0) | number }}
          ถึง {{ ((pageData?.number) * pageData?.size + pageData?.content?.length) | number }}
          จากทั้งหมด {{ pageData?.totalElements | number }} รายการ
        </caption>
        <thead>
        <tr>
          <th scope="col" class="align-middle" nowrap>ลำดับ</th>
          <th scope="col" class="align-middle" nowrap>หมายเลขแจ้งเตือน</th>
          <th scope="col" class="align-middle" nowrap></th>
          <th scope="col" class="align-middle" nowrap>สถานะ</th>
          <th scope="col" class="align-middle" nowrap>รหัสเขต</th>
          <th scope="col" class="align-middle" nowrap>ชื่อเขต</th>
          <th scope="col" class="align-middle" nowrap>รหัสจังหวัด</th>
          <th scope="col" class="align-middle" nowrap>ชื่อจังหวัด</th>
          <th scope="col" class="align-middle" nowrap>รหัสหน่วยบริการประจำที่ได้รับลงทะเบียน</th>
          <th scope="col" class="align-middle" nowrap>ชื่อหน่วยบริการประจำที่ได้รับลงทะเบียน</th>
          <th scope="col" class="align-middle" nowrap>ประเภทรายงาน</th>
          <th scope="col" class="align-middle" nowrap>จำนวน</th>
          <th scope="col" class="align-middle" nowrap>ดาวน์โหลด</th>
          <th scope="col" class="align-middle" nowrap>ผลการตรวจสอบ</th>
          <th scope="col" class="align-middle" nowrap>ไฟล์ข้อมูลผลการตรวจสอบ</th>
          <th scope="col" class="align-middle" nowrap>ระยะเวลาดำเนินการคงเหลือ (วัน)</th>
          @if (isNhso) {
            <th scope="col" class="align-middle" nowrap>บันทึกผล</th>
          }
          <th scope="col" class="align-middle" nowrap>หมายเหตุ</th>
        </tr>
        </thead>
        <tbody>
          @for (item of pageData?.content; let i = $index; track item.id) {
            <tr>
              <th scope="row" class="text-center" nowrap>{{ (pageData.size * pageData.number) + (i + 1) }}</th>
              <th scope="row" class="text-center" nowrap>{{ item.notiNumber }}</th>
              <th scope="row" class="text-center" nowrap>
                @if(item.arbitraryStatus === 'NHSO_OPERATING_AREAS' && isZone){
                  <button class="btn btn-success" type="button" id="btn-download-audit-{{i}}"
                          (click)="finish(item)">
                    <i class="bi bi-check-circle me-2"></i>ไม่พบข้อมูลพลการ
                  </button>
                }
              </th>
              <th scope="row" class="text-left" nowrap>{{ ARBITRARY_STATUS(item.arbitraryStatus) }}</th>
              <th scope="row" class="text-center" nowrap>{{ item?.hmainOp?.province?.zone?.id }}</th>
              <th scope="row" class="text-left" nowrap>{{ item?.hmainOp?.province?.zone?.name }}</th>
              <th scope="row" class="text-center" nowrap>{{ item?.hmainOp?.province?.id }}</th>
              <th scope="row" class="text-left" nowrap>{{ item?.hmainOp?.province?.name }}</th>
              <th scope="row" class="text-center" nowrap>{{ item?.hmainOp?.hcode }}</th>
              <th scope="row" class="text-left" nowrap>{{ item?.hmainOp?.hname }}</th>
              <th scope="row" class="text-left" nowrap>{{ ARBITRARY_TYPE(item.arbitraryType) }}</th>
              <th scope="row" class="text-center" nowrap>{{ item.items?.length }}</th>
              <th scope="row" class="text-center" nowrap>
                <button class="btn btn-outline-success" type="button" id="btn-download-{{i}}"
                        (click)="downloadExcel(item)">
                  <i class="bi bi-file-excel" aria-hidden="true"></i>
                </button>
              </th>
              <th scope="row" class="text-center" nowrap>{{ item.auditDetected }}</th>
              <th scope="row" class="text-center" nowrap>
                @if (item.letterFile) {
                  <button class="btn btn-outline-danger" type="button" id="btn-download-letter-{{i}}"
                          (click)="downloadLetterFile(item)">
                    <i class="bi bi-file-pdf" aria-hidden="true"></i>
                  </button>
                }
                @if (item.auditFile) {
                  <button class="btn btn-outline-success ms-2" type="button" id="btn-download-audit-{{i}}"
                          (click)="downloadResultExcel(item)">
                    <i class="bi bi-file-excel" aria-hidden="true"></i>
                  </button>
                }
              </th>
              <th scope="row" class="text-center"
                  [ngClass]="item?.processRemaining > 0 || item.arbitraryStatus === 'SUMMARIZE_RESULTS' ? 'text-success' : 'text-danger'"
                  nowrap>
                @if (item.arbitraryStatus === 'SUMMARIZE_RESULTS') {
                  <span class="badge bg-success">สำเร็จ</span>
                } @else {
                  {{ item.processRemaining }}
                }
              </th>
              @if (isNhso) {
                <th scope="row" class="text-center" nowrap>
                  @if (item.auditFileDownloadedDate) {
                    <button (click)="taskDetails(item)" id="btn-task-detail-{{i}}"
                            [ngClass]="{'btn-outline-success' : item.arbitraryStatus === 'SUMMARIZE_RESULTS',
                                        'btn-outline-primary' : item.arbitraryStatus !== 'SUMMARIZE_RESULTS'}"
                            type="button" class="btn">
                      @if (item.arbitraryStatus === 'SUMMARIZE_RESULTS') {
                        ดูรายละเอียด
                      } @else {
                        บันทึกผล
                      }
                    </button>
                  }
                </th>
              }
              <th scope="row" class="text-left" nowrap>
                <p [openDelay]="100" [closeDelay]="100"
                   [ngbTooltip]="item.auditRemark">{{ item.auditRemark | shorten: 30: '...' }}</p>
              </th>
            </tr>
          } @empty {
            <tr>
              <td colspan="16">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <ngb-pagination class="d-flex justify-content-center"
                          [maxSize]="5"
                          [rotate]="true"
                          [ellipses]="false"
                          [boundaryLinks]="true"
                          [page]="pageData?.number + 1"
                          (pageChange)="search($event)"
                          [pageSize]="pageData?.size"
                          [collectionSize]="pageData?.totalElements"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
